import { render, staticRenderFns } from "./wap.vue?vue&type=template&id=9bbfb936&scoped=true"
import script from "./wap.vue?vue&type=script&lang=js"
export * from "./wap.vue?vue&type=script&lang=js"
import style0 from "./wap.vue?vue&type=style&index=0&id=9bbfb936&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbfb936",
  null
  
)

export default component.exports